export default function ytVideos() {
    document.querySelectorAll('.media-area__embed .pimcore_tag_video').forEach(mediaArea => {
        const iframe = mediaArea.querySelector('iframe');
        const container = mediaArea.closest('.container-md');
        const caption = container?.querySelector('.media-caption');

        if (iframe && caption) {
            iframe.title = caption.textContent.trim();
        } else if(iframe) {
            iframe.title = 'youtube video';
        }
    });
};
